export const prepareOrderLink = (template: Nullable<string> | undefined, originalOrderNumber?: string): string =>
  template?.replace('{originalOrderNumber}', originalOrderNumber ?? '') ?? '';

export const prepareResultLink = (template: Nullable<string> | undefined, resultId?: string, originalOrderNumber?: string): string =>
  template?.replace('{resultId}', resultId ?? '').replace('{originalOrderNumber}', originalOrderNumber ?? '') ?? '';
